import getAllDas28Jes from "core/components/das28/utils/get-all-das28-jes";
import Patient from "core/models/patient";
import { sortBy } from "core/utils/sort";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import mostRecentJe from "./most-recent-je";
export default function getLastBioExamInfos(patient, bioExamName, loinc) {
  const bioExamsJes = patient.bioExamResultsReceivedJournalEvents.filter(je => je.result(loinc));
  const lastBioExamsJe = bioExamsJes[0];
  const lastDas28JeWithBioExam = getAllDas28Jes(patient)?.filter(je => je[bioExamName]).sort(sortBy("occurredAt", "desc"))[0];
  const lastJe = mostRecentJe(lastBioExamsJe, lastDas28JeWithBioExam);
  const toReturn = {
    occurredAt: lastJe?.occurredAt
  };
  if (lastJe instanceof BioExamResultsReceivedJournalEvent) {
    toReturn[bioExamName] = lastJe?.result(loinc)?.value;
  } else {
    toReturn[bioExamName] = lastJe?.[bioExamName];
  }
  return toReturn;
}